import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-6111df0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "topbar" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "space" }, null, -1))
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-fw fa-sign-out" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "logo",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'apps-store' })))
    }, _hoisted_3),
    _hoisted_4,
    _createVNode(_component_router_link, {
      to: "/logout",
      custom: ""
    }, {
      default: _withCtx(({ navigate }) => [
        _createElementVNode("button", {
          class: "btn btn-transparent",
          onClick: navigate
        }, _hoisted_7, 8, _hoisted_5)
      ]),
      _: 1
    })
  ]))
}